<doc>状态栏</doc>
<template>
  <div class="status-bar-ol">
    <!-- 鼠标位置 -->
    <p class="status-text">
      鼠标位置：{{ mapData.mouseLocation }}
    </p>
    <p class="status-text">
      当前层级：{{ mapData.zoom }}
    </p>
    <p class="status-text">
      可视范围：{{ mapData.range }}
    </p>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  props: {
    mapObject: {
      type: Object,
      default() {
        return {
          mouseLocation: [0, 0],
          zoom: 13,
          range: [0, 0],
        };
      },
    },
    mapConfig: {
      type: Object,
      default() {
        return {
          mouseMove: false,
        };
      },
    },
  },
  computed: {
    ...mapState({
      mapData: state => state.mapData
    })
  },
  watch:{
    mapData(newVal, oldVal) {
      console.log(newVal)
    },
  },
};
</script>
<style scoped>
.status-bar-ol {
  background-color: rgba(0, 60, 136, 0.3);
  position: absolute;
  bottom: 8px;
  right: 10px;
  color: #fff;
  z-index: inherit;
  padding: 3px;
  font-size: 10px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}

.status-text {
  margin: 0 5px;
}
</style>
